import React from "react";
import "./styles.scss";
import WorkspaceBody from "./WorkspaceBody";
import TPMBanner from "./TPMBanner";
const Workspaces = () => {
  const publicURL = process.env.REACT_APP_API_BASE_URL;

  return (
    <div className="workspace-wrapper">
      {/* No page header band here: the "My Contracts" line above the cards
          already names the page, so the 200px "Contract Management" band was
          only spending vertical room. The SHARE deployment keeps its branded
          banner, which carries the donor logos. */}
      {publicURL === "https://shareapi.tpmready.com" && (
        <TPMBanner heading="Third-Party Monitoring (TPM) for the UNICEF & WHO SHARE Project" />
      )}
      <WorkspaceBody />
    </div>
  );
};

export default Workspaces;
